/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PricingError } from './PricingError';
import {
    PricingErrorFromJSON,
    PricingErrorFromJSONTyped,
    PricingErrorToJSON,
} from './PricingError';

/**
 * 
 * @export
 * @interface SIdQuote
 */
export interface SIdQuote {
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    sId?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    bid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    ask?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    bidSize?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    askSize?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    accruedInterest?: string | null;
    /**
     * 
     * @type {Array<PricingError>}
     * @memberof SIdQuote
     */
    errors?: Array<PricingError> | null;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    source?: SIdQuoteSource;
    /**
     * 
     * @type {string}
     * @memberof SIdQuote
     */
    sid?: string;
}


/**
 * @export
 */
export const SIdQuoteSource = {
    MANUAL: 'MANUAL',
    POLYGON: 'POLYGON',
    POLYGON_AT_CLOSE: 'POLYGON_AT_CLOSE',
    IB: 'IB',
    BROKER_DATA: 'BROKER_DATA',
    GOLDEN_FUTURES: 'GOLDEN_FUTURES',
    GOLDEN_BOND: 'GOLDEN_BOND',
    POSITION_REPORT: 'POSITION_REPORT'
} as const;
export type SIdQuoteSource = typeof SIdQuoteSource[keyof typeof SIdQuoteSource];


/**
 * Check if a given object implements the SIdQuote interface.
 */
export function instanceOfSIdQuote(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SIdQuoteFromJSON(json: any): SIdQuote {
    return SIdQuoteFromJSONTyped(json, false);
}

export function SIdQuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SIdQuote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': !exists(json, 'sId') ? undefined : json['sId'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'bid': !exists(json, 'bid') ? undefined : json['bid'],
        'ask': !exists(json, 'ask') ? undefined : json['ask'],
        'bidSize': !exists(json, 'bidSize') ? undefined : json['bidSize'],
        'askSize': !exists(json, 'askSize') ? undefined : json['askSize'],
        'accruedInterest': !exists(json, 'accruedInterest') ? undefined : json['accruedInterest'],
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(PricingErrorFromJSON)),
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
    };
}

export function SIdQuoteToJSON(value?: SIdQuote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sId': value.sId,
        'symbol': value.symbol,
        'bid': value.bid,
        'ask': value.ask,
        'bidSize': value.bidSize,
        'askSize': value.askSize,
        'accruedInterest': value.accruedInterest,
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(PricingErrorToJSON)),
        'timestamp': value.timestamp,
        'source': value.source,
        'sid': value.sid,
    };
}

